export default __webpack_public_path__ + "static/media/4971.25831c57.png";